import constants from '../lib/constants';

export default function authConfig(Vue) {

    Vue.http.interceptors.push((request, next) => {

        request.credentials=true;
        var headers,tokens;
        // token = localStorage.getItem(constants.AUTH_TOKEN_KEY);
        tokens = localStorage.getItem("tokens");
        headers = request.headers || (request.headers = {});
        if (tokens !== null && tokens !== 'undefined') {
            request.headers.set('mem_access_token', tokens);
            request.headers.set('Accept', 'application/json');
        }
        //测试用token
      // request.headers.set('mem_access_token', 'af885c03a23d4c08827b0c32151a0347');
      // request.headers.set('Origin', '*');
        next((response) => {
            if (response.status && response.status.code === 201) {
                localStorage.removeItem(constants.AUTH_TOKEN_KEY);
            }
            if (response.headers && response.headers.Authorization) {
                localStorage.setItem(constants.AUTH_TOKEN_KEY, response.headers.Authorization);
            }
            if (response.entity && response.entity.token && response.entity.token.length > 10) {
                localStorage.setItem(constants.AUTH_TOKEN_KEY, response.entity.token);
            }
            return response;
        })
    });
}



// WEBPACK FOOTER //
// ./src/interceptors/auth_interceptor.js